const routes = [
  {
    path: '/auth/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/view/authentication/SignIn.vue'),
  },
  // {
  //   path: '/auth/register',
  //   name: 'register',
  //   component: () => import(/* webpackChunkName: "register" */ '@/view/authentication/Signup.vue'),
  // },
  {
    path: '/auth/forgotPassword',
    name: 'forgotPassword',
    component: () => import(/* webpackChunkName: "forgotPassword" */ '@/view/authentication/ForgotPassword.vue'),
  },
  {
    path: '/auth/update-password',
    name: 'update-password',
    component: () => import(/* webpackChunkName: "forgotPassword" */ '@/view/authentication/UpdatePassword.vue'),
  },
];

export default routes;
